module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2"
    }
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("A DAIRY TALE")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Okay, I’m back. Let’s get into it. Hopefully, I’ve set the scene for you, the way a farm works in a live-and-let-live manner, the way we understand we’re here to provide services to the humans in return for food, shelter, and safety. We didn’t ask to come here, right? Did you know that cows are not indigenous to North America? No. My ancestors, my great-great-great-great-great-etc.-grandmother came from somewhere in what humans call the Middle East. That’s where the Maker made us and first put our hooves on the ground. They called it the land of milk and honey. And guess who provided the milk? Though I’m told that goats also get milked by humans. Are you kidding me? Come on. No offense, but goat’s milk does not compare with cow’s milk, unless you’re a goat kid. Have you ever seen a cow trying to drink milk from a goat? Case closed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And now I hear stories of humans milking something called an “almond,” and another called a “soy.” I’ve never seen a wild almond or a soy galloping about in its natural habitat, but cow milk is the best. I’d bet three of my four stomachs on it. Of course I’m biased, what else could I be? Bias makes the world go round, sometimes a little too fast. But I digress. And maybe digression isn’t really digression, maybe the shortest distance between two mind points is not a straight line. Chew on that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So there I am, three years old. Mom gone who knows where, but I’m okay. I’m living my life and looking forward to having kids of my own. I’m even looking over the fence at some of those bulls and thinking, “Eh, not so bad.” I never thought I’d say that, but that’s kind of where I was, and it kind of led me to where I am. So one day, me and my bff Mallory were whispering to each other. Mallory is seriously gorgeous, like she could definitely model. She could be the cow on the milk carton. I’ll give you the dialogue, but keep in mind it’s not word-for-word, this is an approximation. I’m not a tape recorder. I’m not an elephant. Though I have some friends who are elephants. Super-cool mammals. Good people. Here it is:")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I don’t know, Elsie, but I kinda wanna go hang out with the bulls all of a sudden. I don’t know what’s gotten into me.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(" (that’s me!)")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I know. Me too.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("What’s wrong with us? When that young bull Frank stomps around and snorts, I get a funny feeling inside and I don’t even care that he’s got boogers totally all over his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I know, I know. I think my mother told me about this, but only kind of. She said that one day the things that interested me then would be boring, and the things that bored me would be interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Your mom was so cool. Where’d she go?")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Yeah. Dunno. Same place as your mom, I guess.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Have you noticed the eldest son sometimes forgets to latch the gate after he milks us? Next time he does it, why don’t we just go out and talk to the bulls?")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("But they’ll see us.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("We’ll do it at night!")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("You’re so smart! The nighttime is the right time. I don’t even know where that came from.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Who are you right now?")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I do not know! I’m totes cray-cray. Oh, look at what that bull Frank is doing right now. Or is that Steve?")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("That’s Steve.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("Yeah, look at him stomp and snort. He is so cool. Good ol’ Steve.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ELSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I thought you liked Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "SPH"
  }, [_c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("MALLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }, [_vm._v("I do. Frank is the bomb. I kinda like them all.")]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("And then we had a bull session, talked about bulls for about twenty minutes, but I won’t tell you what was said ’cause it’s private, and I haven’t gotten in touch yet with Mallory to make sure she can be a character in my story. My editor says I need clearance. And Mallory is not her real name. It isn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And see how that whole scene was kinda written in what’s called “screenplay form”? My editor loves that stuff. Big-shot Hollywood producers take note, this practically shoots itself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So that’s what we did. We waited. Seems like we waited forever. The eldest boy, the one with the pimples and the cell phone, all of a sudden got very conscientious about closing the gate, but I knew it wouldn’t last. Humans are very easily distracted. Especially by their phones. They have a weird and unnatural attachment to those gadgets. I’m not judging, but it’s weird. All right, maybe I am judging. I knew what to do. It was only a matter of time.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0